import { Event } from '../interfaces';

export const isPreImage = (event: Event, isInternal: boolean): boolean => {
  // HACK(CLOUD-5288): We only want to show pre-context images for NYMTA but not PPA.
  // Those are the only 2 fleets that use DOUBLE_PARKED* event types, as of Aug 2025.
  return !isInternal && event.fleet_id === '4e9c24c6-489f-4f2c-9f10-5ab265c2e3d2' && event.event_type_identifier.includes('DOUBLE_PARKED');
};
